import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    CircularProgress, Grid, IconButton,
    Tooltip,
    Typography,
} from "@mui/material";



export default function DVFDetails({selectedItem}) {
    const [open, setOpen] = React.useState(true);

    return ( <Box sx={{display: "flex"}}>
            <Box sx={{
                width: "90%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1
            }}>
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>Prix au m²</Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Max</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].prix_m2_local_max)}/m²
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Min</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].prix_m2_local_min)}/m²
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Moyen</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].prix_m2_local_moyen)}/m²
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Médian</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].prix_m2_local_median)}/m²
                        </Typography>
                    </Box>
                </Box>
            </Box>
            <Box sx={{
                width: "90%",
                borderRadius: "8px",
                backgroundColor: "#f7f9fc",
                padding: 2,
                m: 1
            }}>
                <Box sx={{
                    display: "flex",
                    width: "100%",
                    borderColor: "#000",
                    borderBottomStyle: "solid",
                    height: 30
                }}>
                    <Typography>MONTANT DES TRANSACTIONS</Typography>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Max</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].valeur_fonciere_max)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Min</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].valeur_fonciere_min)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Moyen</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].valeur_fonciere_moyenne)}
                        </Typography>
                    </Box>
                </Box>
                <Box sx={{
                    display: "flex",
                    borderBottomStyle: "dashed",
                    borderWidth: "thin",
                    marginTop: 2,
                    marginBottom: 2,
                    borderColor: "#505050",
                }}>
                    <Box sx={{width: "50%"}}>
                        <Typography color={"#505050"} variant="body2" display="block"
                                    gutterBottom>Médian</Typography>
                    </Box>
                    <Box sx={{width: "50%"}}>
                        <Typography variant="body2"
                                    gutterBottom>
                            {Intl.NumberFormat('fr-FR', {
                                style: 'currency',
                                currency: 'EUR'
                            }).format(selectedItem.metadonnees[0].valeur_fonciere_median)}
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Box>

    )
}

